import { createIdentifierStruct } from "@/modules/api/utils/jsonApiStructs";

import { userResourceType } from "./userResourceConsts";

export const userIdentifierStruct = createIdentifierStruct(userResourceType);
